<app-home-header></app-home-header>
<app-orange-technology></app-orange-technology>
<app-case-studies-overview></app-case-studies-overview>
<app-our-tools></app-our-tools>
<app-footer></app-footer>